export enum UserDeactivationReason {
  FAKE_DOCUMENT = 'FAKE_DOCUMENT',
  ABUSIVE_BEHAVIOR = 'ABUSIVE_BEHAVIOR',
}
